var configs = {
    offset: {
        button: {
            x: -5,
            y: 5
        },
        viewport: {
            x: 20,
            y: 20
        }
    },
    height: {
        max: 880
    },
    width: {
        max: 440
    }
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/addons/dropdown/_configs.js
// module id = 497
// module chunks = 0